// INFO: This Component is designed to be slotted into the Actions.cell.tsx component
// but can also be used anywhere we are using a MUI Menu component and want icons + text
import { type SvgIconComponent } from "@mui/icons-material";
import { ListItemIcon, ListItemText, MenuItem } from "@mui/material";

interface IconMenuItemProps {
  label: string;
  Icon: SvgIconComponent;
  enabled?: boolean;
  onClick: () => void;
}

const IconMenuItem = ({
  onClick,
  Icon,
  label,
  enabled = true,
}: IconMenuItemProps) => {
  if (!enabled) return;

  return (
    <MenuItem onClick={onClick}>
      <ListItemIcon>
        <Icon color="action" />
      </ListItemIcon>
      <ListItemText>{label}</ListItemText>
    </MenuItem>
  );
};
export default IconMenuItem;
